module.exports = __webpack_public_path__ + "blissweb-rg.f00b57f684fc6049e4cf.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/BlissWeb-Rg/blissweb-rg.eot
// module id = 156
// module chunks = 5